module.exports = __webpack_public_path__ + "static/media/west-virginia.9be2fc84.svg";